export default __webpack_public_path__ + "static/target-7927e36ae20c028c16f211996bba1fa1.png";